import Badge from '@/components/pages/badge';
import Image from 'next/image';
import type { CSSProperties } from 'react';
import { recoveryExpertiseIcons } from '@/lib/constants';
import { type CardItem } from './type';

export function Card({ item, style }: { item: CardItem; style?: CSSProperties }) {
  const iconReference = recoveryExpertiseIcons.find(({ name }) => name === item.badge.icon);
  const Icon = iconReference ? iconReference.icon : null;

  return (
    <div className="rounded-2xl overflow-hidden absolute inset-0 @md:relative h-87.5" style={style}>
      <div className="left-4 right-4 mx-4 p-4 flex flex-col items-center text-center text-white gap-2 absolute top-1/2 -translate-y-1/2 z-10 rounded-2xl border border-white/20 bg-blue-950/30 shadow-[0_0_23px_0_rgba(0,0,0,0.25)] backdrop-blur-[23.5px]">
        <Badge label={item.badge.label} icon={<span className="w-4 h-4">{Icon}</span>} />
        <h3 className="font-serif font-normal text-[32px] @md:text-[40px] leading-[1.2] tracking-[-0.02em]">
          {item.title}
        </h3>
        <div
          className="font-sans font-normal text-base"
          dangerouslySetInnerHTML={{ __html: item.description }}
        ></div>
      </div>
      <Image
        src={item.background_image}
        alt={item.title}
        fill
        className="object-cover"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 380px"
      />
    </div>
  );
}
